export interface Article {
  id: string;
  slug: string;
  title: string;
  summary: string;
  categoryId: string;
  categoryName: string;
  categorySlug: string;
  author: string;
  publishDate: string;
  readCount: number;
  hotScore: number;
  isHot: boolean;
  isRecommended: boolean;
  tags: string[];
  imageUrl: string;
  content: string;
}

export const articles: Article[] = [
  {
    id: "1",
    slug: "mou-mingxing-chexiao-hunyin",
    title: "某一线男星被曝连夜撤销婚姻登记，女方手握关键证据",
    summary:
      "据知情人爆料，某顶流男星在昨日深夜紧急撤销婚姻登记，女方已委托律师团队介入，手握三段关键录音和聊天记录。",
    categoryId: "1",
    categoryName: "娱乐八卦",
    categorySlug: "yule-bagua",
    author: "吃瓜小编",
    publishDate: "2026-07-02",
    readCount: 284756,
    hotScore: 98,
    isHot: true,
    isRecommended: true,
    tags: ["明星", "婚姻", "爆料"],
    imageUrl:
      "https://readdy.ai/api/search-image?query=Dramatic%20night%20city%20street%20with%20rain%20reflections%2C%20neon%20signs%20in%20warm%20red%20and%20amber%2C%20mysterious%20silhouette%20of%20person%20under%20umbrella%2C%20cinematic%20noir%20atmosphere%2C%20editorial%20photography&width=800&height=500&seq=cg-art-01&orientation=landscape",
    content: `<p>今日凌晨，有网友在社交平台爆料，某当红一线男星在婚姻登记处连夜办理撤销手续，引发全网热议。据现场目击者称，该男星全程佩戴口罩和墨镜，由助理陪同，神色慌张。</p>

<p><strong>关键证据曝光</strong></p>

<p>女方委托的律师团队已向媒体确认，目前掌握三段关键录音和数百页聊天记录。录音内容涉及男星在婚约期间的多次不当言论，以及涉及财务往来的敏感对话。</p>

<p>据接近女方的人士透露，两人交往期间，男星以「投资」名义向女方借款超过八位数，且至今未归还。女方多次催讨无果，最终选择通过法律途径维权。</p>

<p><strong>品牌方紧急切割</strong></p>

<p>事件发酵后，该男星代言的三个高端品牌已紧急删除相关宣传物料。其中某奢侈品牌官网在凌晨两点完成全面撤换，动作之快引发业内关注。</p>

<p><strong>网友反应</strong></p>

<p>微博话题阅读量已突破2.8亿，评论区呈现两极分化。部分粉丝坚持「等官方声明」，而更多网友则表示「房子塌了」。知名娱乐博主「娱乐圈大侦探」发文称：「这次怕是压不住了。」</p>

<p>截至目前，男星工作室尚未发布任何正式声明。本频道将持续跟进事件进展。</p>`,
  },
  {
    id: "2",
    slug: "wanghong-mei nv-baoliao-daxing",
    title: "千万粉丝网红被前经纪人实名举报：偷税漏税金额惊人",
    summary:
      "前经纪人发布长文，附带上百页转账记录和合同扫描件，指控某头部网红近三年存在严重税务问题。",
    categoryId: "3",
    categoryName: "明星黑料",
    categorySlug: "mingxing-heiliao",
    author: "深度调查组",
    publishDate: "2026-07-02",
    readCount: 198432,
    hotScore: 95,
    isHot: true,
    isRecommended: true,
    tags: ["网红", "税务", "举报"],
    imageUrl:
      "https://readdy.ai/api/search-image?query=Stack%20of%20documents%20and%20financial%20papers%20scattered%20on%20wooden%20desk%20with%20calculator%20and%20pen%2C%20warm%20golden%20lighting%2C%20moody%20atmosphere%2C%20investigative%20journalism%20style&width=800&height=500&seq=cg-art-02&orientation=landscape",
    content: `<p>昨日晚间，某平台千万粉丝级别头部网红的前经纪人在个人微博发布万字长文，实名举报该网红存在严重的偷税漏税行为。文章附带大量转账记录截图和合同扫描件，引发舆论风暴。</p>

<p><strong>举报核心内容</strong></p>

<p>根据举报人提供的资料，该网红自2023年起，通过虚构业务往来、阴阳合同等方式，累计少缴税款金额高达数千万元。举报人表示，自己作为前商务负责人，掌握所有原始合同和银行流水。</p>

<p>文章中特别指出，该网红在2024年单笔广告收入实际到账800万元，但合同签订金额仅为120万元，差额部分通过境外账户转移。举报人已向国家税务总局实名提交相关材料。</p>

<p><strong>平台回应</strong></p>

<p>该网红主要活跃的两个内容平台先后发布声明，表示将配合监管部门调查，并暂时冻结其部分商业功能。知情人士透露，该网红的直播带货排期已全部取消。</p>

<p>税务相关律师分析指出，若举报内容属实，该网红可能面临补缴税款、滞纳金和罚款的三重处罚，情节严重或涉及刑事责任。</p>`,
  },
  {
    id: "3",
    slug: "mou-dianshi-dating-heimu",
    title: "某热门综艺被曝存在系统性黑幕：投票数据可后台篡改",
    summary:
      "节目组前技术人员爆料，观众投票系统存在后门，决赛排名可按照赞助商要求实时调整。",
    categoryId: "2",
    categoryName: "社会热点",
    categorySlug: "shehui-redian",
    author: "内幕揭秘组",
    publishDate: "2026-07-01",
    readCount: 156789,
    hotScore: 91,
    isHot: true,
    isRecommended: false,
    tags: ["综艺", "黑幕", "投票造假"],
    imageUrl:
      "https://readdy.ai/api/search-image?query=Television%20studio%20control%20room%20with%20multiple%20monitors%20showing%20data%20charts%20and%20numbers%2C%20dramatic%20red%20warning%20lights%2C%20warm%20orange%20accent%20lighting%2C%20cinematic%20atmosphere&width=800&height=500&seq=cg-art-03&orientation=landscape",
    content: `<p>某热门选秀综艺节目的前技术人员向多家媒体爆料，该节目的观众投票系统存在严重漏洞，决赛阶段的排名结果可以通过后台程序直接修改。</p>

<p><strong>技术细节曝光</strong></p>

<p>爆料人提供了内部系统的部分截图，显示管理后台存在一个名为「vote_adjust」的函数，可直接修改选手的实时票数。该功能据称是为「应对突发情况」设计的，但在实际使用中，已经成为赞助商干预结果的工具。</p>

<p><strong>赞助商干预</strong></p>

<p>爆料人进一步透露，在节目决赛前一周，赞助商代表会直接发送「期望排名」的邮件给技术团队。技术团队根据要求，在投票截止前30分钟启动数据修正程序，确保指定选手获得目标名次。</p>

<p>该爆料已引发大量参赛粉丝的不满，多个选手的后援会联合发布声明，要求节目组公开原始投票数据并接受第三方审计。</p>`,
  },
  {
    id: "4",
    slug: "lianai-zongyi-jiabin-baoliao",
    title: "恋爱综艺男嘉宾被曝劈腿：同时交往三位女嘉宾",
    summary:
      "节目录制期间，男嘉宾A被曝在节目外同时与另外两位女嘉宾保持恋爱关系，节目组紧急开会。",
    categoryId: "1",
    categoryName: "娱乐八卦",
    categorySlug: "yule-bagua",
    author: "综艺前线",
    publishDate: "2026-07-01",
    readCount: 134521,
    hotScore: 88,
    isHot: true,
    isRecommended: false,
    tags: ["综艺", "恋爱", "劈腿"],
    imageUrl:
      "https://readdy.ai/api/search-image?query=Romantic%20dinner%20table%20setting%20for%20two%20with%20candlelight%20and%20wine%2C%20moody%20warm%20amber%20lighting%2C%20roses%20scattered%20on%20table%2C%20intimate%20atmosphere%2C%20editorial%20photography&width=800&height=500&seq=cg-art-04&orientation=landscape",
    content: `<p>正在热播的恋爱真人秀节目爆出惊人丑闻。据节目组工作人员透露，男嘉宾A在节目录制期间，同时与另外两位女嘉宾保持着暧昧关系，三人均为节目参与者。</p>

<p><strong>时间线梳理</strong></p>

<p>节目于5月初开始录制，男嘉宾A在第一期即与女嘉宾B配对成功。但据知情人士爆料，A在录制间隙多次单独约见女嘉宾C，并在节目组安排的外景期间与女嘉宾D单独相处。</p>

<p>事件曝光源于女嘉宾C的闺蜜在社交媒体发布的一条动态，其中包含A与C的多张亲密合影，拍摄时间正是节目录制期间。随后女嘉宾B的粉丝也翻出A在B面前表示「你是我唯一的选择」的视频片段，与爆料内容形成鲜明对比。</p>

<p><strong>节目组应对</strong></p>

<p>爆料发酵后，节目组在昨日下午紧急召开内部会议。据内部人士称，节目组正在考虑对男嘉宾A进行「劝退」处理，但需要评估已录制素材的损失。</p>

<p>该节目的播出平台方表示正在核实相关情况，承诺将严肃对待任何违背节目规则的行为。</p>`,
  },
  {
    id: "5",
    slug: "yanzhibo-daizhang-shijian",
    title: "颜值主播被指带货神药实为三无产品，已有消费者住院",
    summary:
      "多名消费者反映，购买某百万粉丝主播推荐的减肥产品后出现严重不良反应，已有多人入院治疗。",
    categoryId: "4",
    categoryName: "网络爆料",
    categorySlug: "wangluo-baoliao",
    author: "315调查组",
    publishDate: "2026-06-30",
    readCount: 112345,
    hotScore: 86,
    isHot: false,
    isRecommended: true,
    tags: ["直播带货", "三无产品", "消费者维权"],
    imageUrl:
      "https://readdy.ai/api/search-image?query=Medical%20pills%20and%20supplements%20scattered%20on%20white%20surface%20with%20warning%20labels%20and%20red%20alert%20symbols%2C%20clinical%20lighting%2C%20investigative%20journalism%20photography%20style&width=800&height=500&seq=cg-art-05&orientation=landscape",
    content: `<p>近日，多名消费者在某社交平台发帖称，购买某百万粉丝颜值主播推荐的「瘦身神药」后出现头晕、呕吐等症状，目前已有至少7人被送往医院接受治疗。</p>

<p><strong>消费者遭遇</strong></p>

<p>消费者王女士（化名）向记者表示，她在直播间购买了主播推荐的「燃脂丸」，服用三天后出现心悸和呼吸困难。医院诊断显示，该产品含有未经标注的违禁成分西布曲明，该成分早在2010年就被国家明令禁止。</p>

<p>另一位消费者李先生购买的「排毒胶囊」则被检测出含有泻药成分，长期服用会导致电解质紊乱。李先生表示，主播在直播间声称该产品「纯天然、零副作用、孕妇可食用」。</p>

<p><strong>主播回应</strong></p>

<p>涉事主播昨日发布视频回应，称自己也是「受害者」，产品由供应商提供，自己并未亲自检验。但这一说法被网友反驳：主播在推荐时声称「自己吃了半年」，且产品包装上连生产许可证编号都没有。</p>

<p>目前，涉事产品的生产厂家已被当地市场监管部门查封，主播的直播账号已被平台暂停带货权限。</p>`,
  },
  {
    id: "6",
    slug: "meiri-dasai-0702",
    title: "每日大赛0702：最离谱塌房理由PK赛",
    summary:
      "今日网友票选最离谱的艺人塌房理由，从睡过头到不小心，选手一个比一个离谱。",
    categoryId: "6",
    categoryName: "每日大赛",
    categorySlug: "meiri-dasai",
    author: "大赛组委会",
    publishDate: "2026-07-02",
    readCount: 89234,
    hotScore: 82,
    isHot: false,
    isRecommended: false,
    tags: ["每日大赛", "投票", "塌房"],
    imageUrl:
      "https://readdy.ai/api/search-image?query=Colorful%20voting%20ballot%20boxes%20with%20question%20marks%20floating%20around%20them%2C%20warm%20coral%20and%20peach%20gradient%20background%2C%20playful%20illustration%20style%2C%20modern%20minimalist%20design&width=800&height=500&seq=cg-art-06&orientation=landscape",
    content: `<p>欢迎来到今日每日大赛！本期主题：「最离谱塌房理由」，以下是网友提名的TOP 5选手：</p>

<p><strong>候选人A：某歌手</strong></p>
<p>塌房理由：被拍到与异性同行，回应称「我们只是顺路，我不认识她」。后被扒出两人已是三年情侣，且同居住址一致。</p>

<p><strong>候选人B：某演员</strong></p>
<p>塌房理由：酒驾被抓后声称「我只是喝了藿香正气水」。血液检测结果酒精含量远超醉驾标准。</p>

<p><strong>候选人C：某爱豆</strong></p>
<p>塌房理由：恋爱被曝光，粉丝后援会质问，本人回应「我们只是朋友」。三天后被拍到共同出入月子中心。</p>

<p><strong>候选人D：某主持人</strong></p>
<p>塌房理由：学术造假被曝光，辩称「论文是助理写的，我没看过」。助理随即晒出聊天记录，显示本人逐字逐句修改过三次。</p>

<p><strong>候选人E：某导演</strong></p>
<p>塌房理由：被多名演员指控骚扰，回应「我只是在讲戏」。监控视频显示其「讲戏」内容涉及脱衣示范。</p>

<p>快来投出你的一票！谁的塌房理由最离谱？</p>`,
  },
  {
    id: "7",
    slug: "zhaopian-xiehou-men",
    title: "某女星未修图遭泄露：摄影师怒揭照骗产业链",
    summary:
      "知名摄影师公开对比图，展示某一线女星的真实形象与精修图之间的巨大差距，并曝光团队P图流程。",
    categoryId: "1",
    categoryName: "娱乐八卦",
    categorySlug: "yule-bagua",
    author: "影像揭秘",
    publishDate: "2026-06-29",
    readCount: 87654,
    hotScore: 79,
    isHot: false,
    isRecommended: false,
    tags: ["修图", "照骗", "对比"],
    imageUrl:
      "https://readdy.ai/api/search-image?query=Side%20by%20side%20comparison%20of%20portrait%20photos%20on%20computer%20screen%20with%20photo%20editing%20software%20interface%2C%20warm%20studio%20lighting%2C%20creative%20workspace%20atmosphere&width=800&height=500&seq=cg-art-07&orientation=landscape",
    content: `<p>曾与多位一线女星合作的知名时尚摄影师昨日在社交媒体发布了一组对比照片，引发关于娱乐圈「照骗」文化的广泛讨论。</p>

<p><strong>对比图曝光</strong></p>

<p>摄影师发布了某一线女星同一场活动的原图与精修图对比。原图中女星的身材比例、皮肤状态和五官轮廓与精修图存在明显差异。摄影师配文：「这是同一时刻、同一机位、同一相机的两张照片。」</p>

<p><strong>P图产业链揭秘</strong></p>

<p>摄影师进一步揭露了明星团队的修图流程：一场活动拍摄200张照片，修图团队需在一小时内完成全部精修。修图内容包括磨皮、瘦脸、拉腿、调肤色、甚至重塑五官轮廓。</p>

<p>「最夸张的一次，」摄影师写道，「一位女星要求把照片里的自己修得比旁边的人瘦三圈，而那位旁边的人其实是她的替身。」</p>

<p>该爆料已获得超过50万点赞，评论区充斥着网友「早就知道了」和「还是震惊了」的复杂情绪。</p>`,
  },
  {
    id: "8",
    slug: "heiliao-pugongyingshijian",
    title: "黑料考古：五年前蒲公英事件真相大白",
    summary:
      "当年闹得沸沸扬扬的蒲公英事件有了新进展，当事女方首度公开完整聊天记录，推翻此前所有版本。",
    categoryId: "3",
    categoryName: "明星黑料",
    categorySlug: "mingxing-heiliao",
    author: "历史调查组",
    publishDate: "2026-06-28",
    readCount: 76543,
    hotScore: 74,
    isHot: false,
    isRecommended: true,
    tags: ["考古", "旧闻", "真相"],
    imageUrl:
      "https://readdy.ai/api/search-image?query=Old%20newspaper%20clippings%20and%20aged%20documents%20spread%20on%20vintage%20wooden%20table%20with%20magnifying%20glass%2C%20warm%20amber%20lamp%20light%2C%20detective%20investigation%20atmosphere&width=800&height=500&seq=cg-art-08&orientation=landscape",
    content: `<p>五年前震动娱乐圈的「蒲公英事件」有了最新进展。事件当事女方昨日通过律师发布完整聊天记录，推翻了此前流传的所有版本，引发了新一轮舆论风暴。</p>

<p><strong>事件回顾</strong></p>

<p>「蒲公英事件」得名于当事男方在道歉声明中引用的「蒲公英的约定」歌词。当年，男方被曝与多名女性保持不正当关系，女方随后发布部分聊天记录，男方发布道歉声明后退圈。但事件的完整真相一直众说纷纭。</p>

<p><strong>新证据推翻旧版本</strong></p>

<p>此次公开的完整聊天记录显示，女方当年发布的截图经过选择性裁剪，删除了大量对自己不利的内容。完整的对话记录显示，女方在知情的情况下多次参与男方安排的活动，并收取了高额报酬。</p>

<p>律师表示，公开完整记录是为了「还原真相」，并透露女方这五年来一直遭受不明身份人员的骚扰和威胁，公开记录是经过慎重考虑后的决定。</p>

<p>事件男主角目前已在国外定居，尚未对新进展做出回应。但其前经纪人发文称：「当年我们选择了沉默，不代表我们没有证据。」</p>`,
  },
  {
    id: "9",
    slug: "jingnei-yule-baoliao",
    title: "境外论坛爆料：某国内顶流海外隐秘财产曝光",
    summary:
      "某海外论坛出现匿名爆料帖，详细披露了某国内顶流艺人在海外设立的多家公司和房产信息。",
    categoryId: "4",
    categoryName: "网络爆料",
    categorySlug: "wangluo-baoliao",
    author: "跨境调查组",
    publishDate: "2026-06-27",
    readCount: 65432,
    hotScore: 71,
    isHot: false,
    isRecommended: false,
    tags: ["海外", "资产", "匿名爆料"],
    imageUrl:
      "https://readdy.ai/api/search-image?query=Abstract%20world%20map%20with%20financial%20data%20flow%20lines%20connecting%20offshore%20locations%2C%20warm%20golden%20and%20amber%20color%20palette%2C%20modern%20digital%20illustration%20style&width=800&height=500&seq=cg-art-09&orientation=landscape",
    content: `<p>某境外知名论坛昨日出现一条匿名爆料帖，详细披露了某国内顶流艺人在海外设立的多家离岸公司和多处房产信息，帖子目前已获得超过10万次浏览。</p>

<p><strong>爆料内容</strong></p>

<p>发帖人声称自己是该艺人海外投资团队的前雇员，并提供了据称是内部文件的截图。截图显示，该艺人在英属维尔京群岛、开曼群岛和新加坡注册了多家公司，业务范围涵盖股权投资、艺术品交易和房地产投资。</p>

<p>帖子还列出了该艺人在洛杉矶、伦敦和悉尼的房产信息，总价估算超过2亿美元。发帖人特别指出，这些资产的实际受益人均通过多层离岸架构隐藏。</p>

<p><strong>真伪辨析</strong></p>

<p>虽然爆料内容详实，但多位法律专家指出，仅凭论坛截图无法确认文件真实性。不过，帖中提到的部分公司注册信息，可以通过公开渠道查到，这增加了爆料的可信度。</p>

<p>该艺人工作室在爆料出现后发布简短声明，称「对于网络不实信息保留追究法律责任的权利」，但未正面回应具体内容。</p>`,
  },
  {
    id: "10",
    slug: "zhizuo-gongsi-neimu",
    title: "影视制作公司内部群聊泄露：选角竟看后台关系图",
    summary:
      "某中型影视公司工作群聊截图流出，显示选角标准与艺人专业度无关，完全取决于其后台关系评分。",
    categoryId: "2",
    categoryName: "社会热点",
    categorySlug: "shehui-redian",
    author: "职场揭秘组",
    publishDate: "2026-06-26",
    readCount: 54321,
    hotScore: 68,
    isHot: false,
    isRecommended: false,
    tags: ["职场", "选角", "内幕"],
    imageUrl:
      "https://readdy.ai/api/search-image?query=Film%20studio%20backstage%20with%20casting%20chairs%20and%20call%20sheets%20on%20wall%2C%20dramatic%20red%20and%20warm%20amber%20stage%20lighting%2C%20moody%20cinematic%20atmosphere%2C%20editorial%20photography&width=800&height=500&seq=cg-art-10&orientation=landscape",
    content: `<p>某影视制作公司的内部工作群聊截图昨日在网络上流传，揭示了该公司选角过程中令人震惊的操作方式：所有候选演员都被打上了「后台关系」评分，评分高低直接决定是否获得角色。</p>

<p><strong>后台关系图曝光</strong></p>

<p>流出的截图显示，公司制作部有一份Excel表格，记录了所有合作过的演员及其「后台资源」。评分维度包括：父母职业、签约公司背景、圈内人脉关系、社交媒体粉丝量等。每个演员的总分直接决定其可获得的角色等级。</p>

<p>表格中甚至标注了「红色」（高层关系）、「黄色」（中层关系）和「绿色」（无背景）三类标签。据截图显示，一位演技备受好评的「绿色」演员，在竞争某重要配角时被「红色」标签的新人直接取代。</p>

<p><strong>行业反响</strong></p>

<p>多位业内人士对此表示「见怪不怪」。知名制片人A在微博上隐晦回应：「这个圈子谁不是靠关系？只是有人把潜规则做成了Excel而已。」</p>

<p>该公司目前尚未对泄露事件做出正式回应，但据内部人士透露，公司已开始全面排查信息泄露源头。</p>`,
  },
  {
    id: "11",
    slug: "jinri-jiugua-0702",
    title: "今日必吃瓜0702：某导演被十八线演员实名举报潜规则",
    summary:
      "一名出道五年的十八线女演员今日发布长文，实名举报某知名导演在拍摄期间多次骚扰，并附有录音证据。",
    categoryId: "5",
    categoryName: "今日大瓜",
    categorySlug: "jinri-dagua",
    author: "今日值班员",
    publishDate: "2026-07-02",
    readCount: 167890,
    hotScore: 97,
    isHot: true,
    isRecommended: true,
    tags: ["今日大瓜", "潜规则", "实名举报"],
    imageUrl:
      "https://readdy.ai/api/search-image?query=Film%20director%20chair%20on%20movie%20set%20with%20clapperboard%20and%20camera%20equipment%2C%20dramatic%20spotlight%20with%20red%20and%20warm%20amber%20tones%2C%20moody%20atmosphere%2C%20editorial%20photography&width=800&height=500&seq=cg-art-11&orientation=landscape",
    content: `<p>今日上午，一名出道五年但始终未获得知名度的女演员在微博发布长文，实名举报某拍摄过十余部热门剧集的知名导演在拍摄期间对她进行多次骚扰。</p>

<p><strong>详细指控</strong></p>

<p>女演员称，在2025年拍摄某古装剧期间，该导演以「讲戏」为名多次要求她单独到其酒店房间，并在她拒绝后以各种方式施压，包括威胁删减她的戏份、影响其后续接戏等。</p>

<p>文章附有一段时长8分钟的录音。录音中，可以听到一名男性声音要求女演员「听话」，并表示「在这个圈子里，不听话的人没有出路」。女演员在录音中多次明确表示拒绝。</p>

<p><strong>导演回应</strong></p>

<p>被举报的导演在下午发布声明，否认所有指控，称「对方是在为新剧炒作」，并表示将起诉该女演员「诽谤」。但网友发现，导演声明中并未解释录音的真实性。</p>

<p><strong>连锁反应</strong></p>

<p>该导演正在拍摄的新剧剧组已有多名演员提出解约，投资方紧急开会评估风险。此外，又有两名女演员通过匿名账号表示「也有类似经历」，事件影响正在持续扩大。</p>`,
  },
  {
    id: "12",
    slug: "meiri-dasai-0701",
    title: "每日大赛0701：最尴尬同框决赛投票",
    summary:
      "网友票选娱乐圈最尴尬的明星同框瞬间，从分手情侣到竞争对手，场面一度十分精彩。",
    categoryId: "6",
    categoryName: "每日大赛",
    categorySlug: "meiri-dasai",
    author: "大赛组委会",
    publishDate: "2026-07-01",
    readCount: 72345,
    hotScore: 77,
    isHot: false,
    isRecommended: false,
    tags: ["每日大赛", "投票", "同框"],
    imageUrl:
      "https://readdy.ai/api/search-image?query=Red%20carpet%20event%20with%20two%20celebrities%20standing%20awkwardly%20apart%20with%20forced%20smiles%2C%20warm%20golden%20spotlights%2C%20flash%20photography%20atmosphere%2C%20glamorous%20but%20tense%20mood&width=800&height=500&seq=cg-art-12&orientation=landscape",
    content: `<p>今日每日大赛主题：「最尴尬同框」。以下是网友提名的TOP 3尴尬瞬间：</p>

<p><strong>候选人A：分手情侣被迫同台</strong></p>
<p>某颁奖典礼上，分手三年的前情侣被安排邻座。全程零交流，男方假装看手机，女方与另一侧的嘉宾频繁交谈，气氛尴尬到冰点。</p>

<p><strong>候选人B：竞争对手肩并肩</strong></p>
<p>两位因资源争夺而暗中较劲的一线女星，在品牌活动中被安排一起剪彩。全程皮笑肉不笑，媒体拍照时两人同时往相反方向侧身，导致合影中只有中间的品牌logo是正的。</p>

<p><strong>候选人C：互撕过的艺人同台</strong></p>
<p>两位曾在社交媒体上公开互撕的男演员，被剧组安排为某综艺的飞行嘉宾。导演组故意设计了需要两人互动的游戏环节，其中一位全程黑脸，另一位则夸张地表演「友好」。</p>

<p>投出你的一票！你觉得哪个同框最尴尬？</p>`,
  },
];

export function getArticleById(id: string): Article | undefined {
  return articles.find((a) => a.id === id);
}

export function getArticleBySlug(slug: string): Article | undefined {
  return articles.find((a) => a.slug === slug);
}

export function getArticlesByCategory(slug: string): Article[] {
  return articles.filter((a) => a.categorySlug === slug);
}

export function getHotArticles(limit: number = 6): Article[] {
  return [...articles].sort((a, b) => b.hotScore - a.hotScore).slice(0, limit);
}

export function getRecommendedArticles(limit: number = 4): Article[] {
  return articles
    .filter((a) => a.isRecommended)
    .sort((a, b) => b.hotScore - a.hotScore)
    .slice(0, limit);
}

export function getLatestArticles(limit: number = 6): Article[] {
  return [...articles]
    .sort(
      (a, b) =>
        new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime()
    )
    .slice(0, limit);
}

export function getRelatedArticles(
  currentId: string,
  categorySlug: string,
  limit: number = 4
): Article[] {
  return articles
    .filter((a) => a.id !== currentId && a.categorySlug === categorySlug)
    .sort((a, b) => b.hotScore - a.hotScore)
    .slice(0, limit);
}